import { useEffect, useState } from "react";
import { obraService } from "../../../../pages/obra/service/obra.service";
import { SelectField } from "../../ui";

interface Obra {
  id: string;
  workName: string;
  idClient: string;
}

interface SelectObraProps {
  value: string;
  onChange: (id: string, name?: string) => void;
  idCliente?: string;
  required?: boolean;
  disabled?: boolean;
}

export function SelectObra({
  value,
  onChange,
  idCliente,
  required,
  disabled = false,
}: SelectObraProps) {
  const [obras, setObras] = useState<Obra[]>([]);
  const [obrasPorClientes, setObrasPorClientes] = useState<Obra[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await obraService.selectObra();
        setObras(data ?? []);
      } catch (error) {
        console.error("Erro ao carregar obras:", error);
        setObras([]);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (idCliente) {
      setObrasPorClientes(obras.filter((obra) => obra.idClient === idCliente));
    } else {
      setObrasPorClientes(obras);
    }
  }, [obras, idCliente]);

  const selectedValue = typeof value === "string" ? value : "";

  return (
    <SelectField
      label="Selecione uma Obra"
      value={selectedValue}
      onChange={(e) => {
        const selectedId = e.target.value;
        const obraSelecionada = obras.find((o) => o.id === selectedId);
        onChange(selectedId, obraSelecionada?.workName);
      }}
      required={required}
      disabled={disabled}
    >
      <option value="">Selecione...</option>
      {obrasPorClientes.map((obra) => (
        <option key={obra.id} value={obra.id}>
          {obra.workName}
        </option>
      ))}
    </SelectField>
  );
}
